export default __webpack_public_path__ + "static/card-visa-debit@2x-9f8be64239aec28c7b15062a90687d1c.png";